import React from 'react';
import { string, func, array, object } from 'prop-types';
import { Select } from 'antd';
const { Option }  = Select;

const CPSelect = (props) => {

	let options = props.options.map(item => {
		return(
			<Option
				key={item.value}
				value={item.value}>
				{item.label || item.text}
				</Option>);
	});

	return (
		<Select
			value={props.selectedValue}
			id={props.id}
			className={`cp-select ${props.className}`}
			onChange={props.onChange}
			style={props.style}
		>
			{options}
		</Select>
	);
};

CPSelect.propTypes = {
	className: string,
	id: string,
	selectedValue: string.isRequired,
	onChange: func.isRequired,
	options: array.isRequired,
	style:object,
};

export default CPSelect;


// WEBPACK FOOTER //
// ./src/views/components/generic/select/Select.jsx